import * as React from 'react'

import Svg, { Path } from 'react-native-svg'

import { IconProps } from '..'

const CreditCardCategories = ({
  size = 24,
  color = '#000',
  ...props
}: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 28 28"
    fill="none"
    {...props}
  >
    <Path
      d="M26.192 18.49 6.935 21.886a2.187 2.187 0 0 1-2.534-1.775L2.28 8.091a2.187 2.187 0 0 1 1.775-2.535l19.256-3.395a2.188 2.188 0 0 1 2.535 1.774l2.12 12.021a2.187 2.187 0 0 1-1.775 2.534Z"
      fill="#1F539E"
    />
    <Path
      d="m23.313 2.16-9.629 1.698 2.88 16.33 9.628-1.698a2.187 2.187 0 0 0 1.774-2.534l-2.12-12.021a2.187 2.187 0 0 0-2.533-1.774Z"
      fill="#153463"
    />
    <Path
      d="M21.328 25.873H2.188A2.188 2.188 0 0 1 0 23.686V11.779c0-1.208.98-2.187 2.188-2.187h19.14c1.208 0 2.188.98 2.188 2.187v11.907c0 1.208-.98 2.187-2.188 2.187Z"
      fill="#94BFFF"
    />
    <Path
      d="M21.328 9.592h-9.57v16.281h9.57c1.208 0 2.188-.98 2.188-2.187V11.779c0-1.208-.98-2.187-2.188-2.187Z"
      fill="#69A6FF"
    />
    <Path d="M0 13.313h23.516v3.722H0v-3.722Z" fill="#ECF6FD" />
    <Path
      d="M6.513 22.262H2.79a.82.82 0 0 0 0 1.64h3.722a.82.82 0 1 0 0-1.64Z"
      fill="#EAF6FF"
    />
    <Path d="M11.758 13.313h11.758v3.722H11.758v-3.722Z" fill="#D6E8FE" />
  </Svg>
)

export default CreditCardCategories
